import script from "./FormContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./FormContainer.vue?vue&type=script&setup=true&lang=js"

import "./FormContainer.vue?vue&type=style&index=0&id=ca2860da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca2860da"]])

export default __exports__